import { render, staticRenderFns } from "./RtCommonFooterText.vue?vue&type=template&id=70ec209e&scoped=true"
import script from "./RtCommonFooterText.vue?vue&type=script&setup=true&lang=ts"
export * from "./RtCommonFooterText.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RtCommonFooterText.vue?vue&type=style&index=0&id=70ec209e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec209e",
  null
  
)

export default component.exports